export interface SeoData {
  title: string;
  description: string;
  keywords?: string;
  path: string;
  ogType?: string;
  image?: string;
}

export const SEO_IMAGES = {
  home:
    'https://readdy.ai/api/search-image?query=Curated%20sneaker%20and%20streetwear%20collection%20displayed%20on%20floating%20white%20shelves%2C%20soft%20warm%20natural%20light%2C%20mint%20green%20and%20cream%20pastel%20accents%2C%20clean%20modern%20editorial%20photography%2C%20airy%20minimal%20aesthetic&width=1600&height=900&seq=hero-main-2026&orientation=landscape&nocache=true',
  article:
    'https://readdy.ai/api/search-image?query=Modern%20minimal%20workspace%20with%20laptop%20showing%20a%20product%20spreadsheet%2C%20clean%20white%20desk%2C%20coffee%20cup%2C%20soft%20natural%20light%20from%20a%20window%2C%20warm%20neutral%20tones%2C%20editorial%20photography%2C%20productive%20calm%20aesthetic&width=1200&height=675&seq=article-body-01-v2&orientation=landscape',
  products:
    'https://readdy.ai/api/search-image?query=Modern%20e-commerce%20product%20showcase%20with%20luxury%20fashion%20items%20arranged%20on%20clean%20white%20surface%2C%20soft%20natural%20lighting%2C%20minimalist%20editorial%20photography%2C%20warm%20neutral%20tones&width=1600&height=400&seq=products-hero-bg&orientation=landscape',
};

function getSiteUrl(): string {
  const configured = import.meta.env.VITE_SITE_URL as string | undefined;
  if (configured && configured.trim()) {
    return configured.trim().replace(/\/+$/, '');
  }
  return 'https://cssbuybr.work';
}

export function siteUrl(): string {
  return getSiteUrl();
}

export function absoluteUrl(path: string): string {
  const base = getSiteUrl();
  if (!path) return base + '/';
  if (/^https?:\/\//.test(path)) return path;
  return base + (path.startsWith('/') ? path : '/' + path);
}

function ensureMeta(attr: 'name' | 'property', key: string): HTMLMetaElement {
  let el = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  return el;
}

function setMeta(attr: 'name' | 'property', key: string, content: string): void {
  const el = ensureMeta(attr, key);
  el.setAttribute('content', content);
}

function ensureCanonical(): HTMLLinkElement {
  let el = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]');
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', 'canonical');
    document.head.appendChild(el);
  }
  return el;
}

export function applySeo(seo: SeoData): void {
  if (typeof document === 'undefined') return;

  document.title = seo.title;
  setMeta('name', 'description', seo.description);
  setMeta('name', 'keywords', seo.keywords || '');
  ensureCanonical().setAttribute('href', absoluteUrl(seo.path));

  const url = absoluteUrl(seo.path);
  const type = seo.ogType || 'website';

  setMeta('property', 'og:title', seo.title);
  setMeta('property', 'og:description', seo.description);
  setMeta('property', 'og:type', type);
  setMeta('property', 'og:url', url);
  if (seo.image) setMeta('property', 'og:image', seo.image);

  setMeta('name', 'twitter:card', 'summary_large_image');
  setMeta('name', 'twitter:title', seo.title);
  setMeta('name', 'twitter:description', seo.description);
  if (seo.image) setMeta('name', 'twitter:image', seo.image);
}